define(
    "diy/undo-redo/historyEntry/Pages",
    [
        'diy/undo-redo/historyEntry/Base',
        'diy/site-admin/main/siteadmin'
    ],
    /**
     *
     * @param {module.undoRedo.HistoryEntry.Base} HistoryEntry
     * @returns {*}
     */
    function (HistoryEntry, siteadmin) {
        'use strict';
        var Pages;
        /**
         * @class module.undoRedo.HistoryEntry.Pages
         * @template module.undoRedo.HistoryEntry.Pages
         * @lends {module.undoRedo.HistoryEntry.Pages.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Pages = HistoryEntry.extend({

            payload: {},

            message: '',
            onExecutedLast: function (executionData) {
                // no interface changes on this action
            },

            onExecuted: function (executionData) {
                //close the site-admin window
                var controller = siteadmin.getController();

                if (controller !== null && controller.isOpened()) {
                    controller.close();
                    diy.editor.navigation.api.notify('force_update');
                } else {
                    diy.editor.navigation.api.updateJimdoData(
                        function (data) {
                            diy.editor.navigation.api.verifyCurrentPage(
                                data,
                                function () {
                                    diy.editor.navigation.api.notify('force_update');
                                },
                                function (redirectUrl) {
                                    this.api.requestBrowserReload(redirectUrl);
                                }.bind(this)
                            );
                        }.bind(this)
                    );
                }

                if (executionData.payload.shouldReloadPage === true) {
                    this.api.requestBrowserReload();
                }

                return this._super(executionData);
            },

            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            }
        });
        return Pages;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/historyEntry/Pages.js
 ** module id = 903
 ** module chunks = 0
 **/